// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { xglobal } from '@polkadot/x-global';
import { isFunction } from "./is/function.mjs";
import { isString } from "./is/string.mjs";
import { assert } from "./assert.mjs"; // eslint-disable-next-line no-undef

/** @internal */
function expandPath(path) {
  return !path || path.length < 5 ? '<unknown>' : path;
}
/** @internal */


function getEntry(name) {
  const _global = xglobal;

  if (!_global.__polkadotjs) {
    _global.__polkadotjs = {};
  }

  if (!_global.__polkadotjs[name]) {
    _global.__polkadotjs[name] = [];
  }

  return _global.__polkadotjs[name];
}
/** @internal */


function flattenVersions(entry) {
  const all = entry.map(version => isString(version) ? {
    version
  } : version);
  const verLength = all.reduce((max, {
    version
  }) => Math.max(max, version.length), 0);
  return all.map(({
    path,
    version
  }) => `\t${version.padEnd(verLength)}\t${expandPath(path)}`).join('\n');
}
/** @internal */


function getPath(pathOrFn) {
  if (isFunction(pathOrFn)) {
    try {
      return pathOrFn();
    } catch (error) {
      return undefined;
    }
  }

  return pathOrFn;
}
/**
 * @name detectPackage
 * @summary Checks that a specific package is only imported once
 */


export function detectPackage({
  name,
  version
}, pathOrFn) {
  assert(name.startsWith('@polkadot'), `Invalid package descriptor ${name}`);
  const entry = getEntry(name);
  entry.push({
    path: getPath(pathOrFn) || '',
    version
  });

  if (entry.length !== 1) {
    console.warn(`Multiple instances of ${name} detected, ensure that there is only one package in your dependency tree.\n${flattenVersions(entry)}`);
  }
}